import { createContext } from 'react';

const ModalContext = createContext({
    isBodyScrolled: false,
    setIsBodyScrolled: () => { },
});

export { ModalContext };
//# sourceMappingURL=ModalContext.js.map
